// extracted by mini-css-extract-plugin
export var productImage = "_rb-1";
export var viewLink = "_rb-2";
export var wishlistItem = "_rb-0";